export default __webpack_public_path__ + "static/SRF 1100 - Fiche de spécifications et données techniques-c44e118705f175e1c24708ae30fd43d5.pdf";